var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import { get } from "lodash";
import styled from "styled-components";
import idHelper from "@irati/utils/id";
import authentication from "@irati/auth";
import { connect } from "@irati/store";
import { FormattedCurrency, FormattedMessage, injectIntl } from "@irati/utils/lang";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import notify from "@irati/utils/notify";
import { walletTracking } from "@irati-tracking/wallet";
import { Caption, SmallCaption } from "@irati/ui/src/Labels";
import Icon from "@irati/ui/src/Icon";
import { greys } from "@irati/ui/src/global/colors";
import HeaderLink from "../../shared/HeaderLink";
var StyledCaption = styled(Caption)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: initial;\n  margin-left: 10px;\n"], ["\n  display: initial;\n  margin-left: 10px;\n"])));
var StyledSmallCaption = styled(SmallCaption)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: initial;\n  margin-left: 10px;\n  color: ", ";\n"], ["\n  display: initial;\n  margin-left: 10px;\n  color: ", ";\n"])), greys.medium);
var FlexDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TitleWithWallet = /** @class */ (function (_super) {
    __extends(TitleWithWallet, _super);
    function TitleWithWallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TitleWithWallet.prototype.componentDidMount = function () {
        var _a = this.props, requested = _a.wallet.requested, getWallet = _a.getWallet, formatMessage = _a.formatMessage;
        if (!requested) {
            getWallet().catch(function () {
                notify.error({ message: formatMessage({ id: "platform.nav.wallet.get.error" }), position: "top-right" });
            });
        }
    };
    TitleWithWallet.prototype.render = function () {
        var _a = this.props, id = _a.id, wallet = _a.wallet, isTablet = _a.isTablet;
        var availableBalance = wallet.availableBalance, currency = wallet.currency, scheduledInBalance = wallet.scheduledInBalance;
        var WALLET = this.context.apps.WALLET;
        // Always hide the value if user is admin and is in a tablet or smaller,
        // to make sure the nav header doesn't break
        var hasAdminAccess = authentication.hasAdminAccess();
        var hideBalances = isTablet && hasAdminAccess;
        return (React.createElement(HeaderLink, { app: WALLET, id: idHelper("link-wallet", id), marginRight: true, onClick: function () { return walletTracking.clickWalletBalance(availableBalance, currency); }, to: "/" },
            React.createElement(Icon, { icon: "wallet", large: true }),
            !hideBalances && currency &&
                React.createElement(FlexDiv, null,
                    (availableBalance > 0 || scheduledInBalance > 0) &&
                        React.createElement(StyledCaption, { flush: true, bold: true },
                            React.createElement(FormattedCurrency, { isCents: false, value: availableBalance, currency: currency })),
                    scheduledInBalance > 0 &&
                        React.createElement(StyledSmallCaption, { flush: true },
                            React.createElement(FormattedMessage, { id: "platform.wallet.menu.title.pending", values: { pendingBalance: React.createElement(FormattedCurrency, { isCents: false, value: scheduledInBalance, currency: currency }) } })))));
    };
    TitleWithWallet.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return TitleWithWallet;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet, mq = _a.mq;
    return ({
        wallet: wallet,
        isTablet: get(mq, "lessThan.large", false)
    });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TitleWithWallet));
var templateObject_1, templateObject_2, templateObject_3;
